module.exports = __webpack_public_path__ + "img/evoluq_logo.3445ab9f.svg";